var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 58,
    viewBox: "0 0 49 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.32 53.5V56.34H1V1H42.32V30.5",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 11.38H31.7205",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 18.3H21.2105",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 25.21H31.7205",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 32.13H31.7205",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 39.05H31.7205",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 45.97H24.3505",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33,
    width: 3,
    height: 18,
    rx: 1.5,
    fill: "#5D68B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40.5C37 37.4624 39.4624 35 42.5 35C45.5376 35 48 37.4624 48 40.5V47H37V40.5Z",
    fill: "white",
    stroke: "#5D68B0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.e7079c819a4db657898b781c1a32009f.svg";
export { ForwardRef as ReactComponent };